import { render, staticRenderFns } from "./borrowingDetail.vue?vue&type=template&id=54e85ba8&scoped=true&"
import script from "./borrowingDetail.vue?vue&type=script&lang=js&"
export * from "./borrowingDetail.vue?vue&type=script&lang=js&"
import style0 from "./borrowingDetail.vue?vue&type=style&index=0&id=54e85ba8&prod&lang=less&scoped=true&"
import style1 from "./borrowingDetail.vue?vue&type=style&index=1&id=54e85ba8&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54e85ba8",
  null
  
)

export default component.exports